'use client';

import { useEffect, useMemo } from 'react';
import { usePathname } from 'next/navigation';
import { useSession } from 'next-auth/react';
import { useGetProfileInfoQuery } from '@akinon/next/data/client/account';
import { pcProfileSet } from '@theme/utils/personaclick';

export default function PersonaProfileWatcher() {
  const pathname = usePathname();
  const { status } = useSession();


  const { data: profileInfo } = useGetProfileInfoQuery(undefined, {
    skip: status !== 'authenticated',
  });

  const payload = useMemo(() => {
    const p: any = profileInfo;
    if (!p) return null;

    const g = (p.gender || '').toString().toLowerCase();
    const gender = g === 'male' ? 'm' : g === 'female' ? 'f' : undefined;

    return {
      id: p.id ?? p.pk,
      email: p.email,
      phone: p.phone,
      first_name: p.first_name,
      last_name: p.last_name,
      gender,
      date_of_birth: p.date_of_birth,
    };
  }, [profileInfo]);

  useEffect(() => {
    if (status !== 'authenticated') return;
    if (!payload) return;

    pcProfileSet(payload);
  }, [status, pathname, payload]);

  return null;
}
